module.exports = __webpack_public_path__ + "static/media/calendar-history.79b5d5ef.svg";